import React from 'react';
import { Link } from 'react-router-dom';
import SidebarProfile from './SideBarProfile';
import EditPicture from '../../components/user-profile/edit-user-logo';

export default function UserProfile(props) {
  return (
    <div className="content-wrapper">
      <div>
        {/* Main content */}
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="card">
                  {/* /.card-header */}
                  <div className="card-body">
                    <EditPicture
                      ui="/cms/user/profile"
                      epr="/cms/user/profile"
                      edpr="/cms-edit-user-profile"
                      epic="/cms-edit-user-profile-picture"
                      elog="/cms-edit-user-company-logo"
                    >
                      <SidebarProfile />
                    </EditPicture>
                  </div>
                  {/* /.card-body */}
                </div>
                {/* /.card */}
                {/* /.card */}
              </div>
              {/* /.col */}
            </div>
            {/* /.row */}
          </div>
          {/* /.container-fluid */}
        </section>
        {/* /.content */}
      </div>
    </div>
  );
}
